export default "__VITE_ASSET__7010b9aa__"